import { useEffect, useRef } from "react";

declare global {
  interface Window {
    birdieSettings?: {
      app_id: string;
      user_id: string;
      email: string;
      name: string;
    };
  }
}

interface BirdieWidgetProps {
  userId: number;
  email: string;
  name: string | null;
}

export function BirdieWidget({ userId, email, name }: BirdieWidgetProps) {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    window.birdieSettings = {
      app_id: "imzit8oj",
      user_id: String(userId),
      email,
      name: name ?? email,
    };

    const script = document.createElement("script");
    script.src = "https://birdie.so/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      delete window.birdieSettings;
      script.remove();
    };
  }, [userId, email, name]);

  return null;
}
